import React, {useMemo, useRef, useEffect} from 'react'
import './DateTimeIndicator.scss'

const DateTimeIndicator = ({startSec, pos, primaryHeaders}) => {
  const refTimelineEvents = useRef(null)
  const width = useMemo(() => {
    if (!primaryHeaders.length) return 0

    const nearestIndex = primaryHeaders.findIndex(e => startSec >= e.sec && startSec <= e.endSec) // get first instance
    let right = 0

    // get percentage value
    if (nearestIndex !== -1) {
      const normNearest = primaryHeaders[nearestIndex].endSec - primaryHeaders[nearestIndex].sec
      const normStart = startSec - primaryHeaders[nearestIndex].sec
      const percStart = normStart / normNearest
      right =
        nearestIndex * primaryHeaders[nearestIndex].width +
        percStart * primaryHeaders[nearestIndex].width
    }

    const last = primaryHeaders[primaryHeaders.length - 1]
    const scrollAdjustment = primaryHeaders[0].width - 26
    return (last.endSec < startSec ? primaryHeaders.length * last.width : right) - scrollAdjustment
  }, [startSec, primaryHeaders])

  return (
    <div
      style={{
        display: width > 0 ? 'block' : 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        left: 160,
        bottom: 0,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          display: width === 0 ? 'none' : null,
        }}
        className="ap-reservation-gantt-date-time-selector"
      >
        <div
          style={{width: width, left: 0}}
          className={` ap-reservation-gantt-date-time-selector__indicator`}
        ></div>
      </div>
    </div>
  )
}

export default DateTimeIndicator
